import styled from 'styled-components';

export const BlogPostListWrapper = styled.section`
  display: flex;
  flex-direction: column;
  align-content: center;
  justify-content: center;
  div.bogPostList--title {
    text-align: center;
    margin-bottom: 45px;
  }
  ul {
    list-style-type: none;
  }
`;
